/* @flow */
import { combineReducers } from 'redux-immutable';
import { Map } from 'immutable';
import createDebugger from 'debug';
import type { Action } from 'trustar/utils/redux-types.js';

const debug = createDebugger('app:modules:errors:stores'); // eslint-disable-line no-unused-vars

import * as ActionTypes from './action-types'; 

export const hasError = (state: boolean = false, action: Action<*>) => {
  switch (action.type) {
  case ActionTypes.GLOBAL_ERROR_THROW:
    return true;
  case ActionTypes.GLOBAL_ERROR_CAUGHT:
    return false;
  default:
    return state;
  }
};

export const error = (state: any = Map(), action: Action<*>) => {
  switch(action.type) {
    case ActionTypes.GLOBAL_ERROR_ACKNOWLEDGED:
      return Map();
    case ActionTypes.GLOBAL_ERROR_THROW:
      return Map(action.payload.error);
    default:
      return state;
  }
}

export const info = (state: any = Map(), action: Action<*>) => {
  switch(action.type) {
    case ActionTypes.GLOBAL_ERROR_ACKNOWLEDGED:
      return Map();
    case ActionTypes.GLOBAL_ERROR_THROW:
      return Map(action.payload.info);
    default:
      return state;
  }
}

export default combineReducers({
  hasError,
  error,
  info
});



// WEBPACK FOOTER //
// ./src/app/modules/errors/stores.js